module.exports = __webpack_public_path__ + "img/arte-destaques-grand-home.45a238a3.jpg";